import { PlusIcon } from 'lucide-react';

import type { FlatGraphNode } from '@/sections/insights/queryBuilder/types/FlatGraph';

interface NodeAddRelationshipProps {
  node: FlatGraphNode;
  editable: boolean;
  onAddRelationship?: (nodeId: string) => void;
}

/**
 * NodeAddRelationship - Renders "Add Relationship" button at bottom of card
 * Only visible in editable mode with onAddRelationship callback
 */
export const NodeAddRelationship = ({
  node,
  editable,
  onAddRelationship,
}: NodeAddRelationshipProps) => {
  if (!editable || !onAddRelationship) {
    return null;
  }

  return (
    <button
      onClick={() => onAddRelationship(node.id)}
      className="border-chariot-stroke text-chariot-brand-primary hover:bg-chariot-background-secondary flex w-full items-center justify-center gap-2 rounded-b-lg border-t py-2 text-sm font-medium transition-colors"
      data-testid={`add-relationship-${node.id}`}
      aria-label={`Add relationship after ${node.data.labels?.[0] || 'Unknown'} node`}
    >
      <PlusIcon className="h-4 w-4" />
      <span>Add Node</span>
    </button>
  );
};
